import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { ID } from "@types";
import {
  IAdvantageLevel,
  getServiceProviderAdvantageLevel,
} from "../services/serviceProviders";

export const useServiceProviderAdvantageLevel = (
  serviceProviderId: ID | undefined
) => {
  const { data, isLoading, isError, isSuccess } = useDataQuery(
    ["superTalentAdvantageLevel", Number(serviceProviderId)],
    async () => {
      const response = await getServiceProviderAdvantageLevel(serviceProviderId);
      return response.data;
    },
    {
      enabled: !!serviceProviderId,
      staleTime: 60 * 5000,
    }
  );

  return { data: data as IAdvantageLevel | undefined, isLoading, isError, isSuccess };
};
